import { Path, Svg, SvgProps } from 'react-native-svg'

export default function ItFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M20 0H0V40H20V0Z" fill="#009246" />
      <Path d="M40 0H20V40H40V0Z" fill="#ffffff" />
      <Path d="M60 0H40V40H60V0Z" fill="#ce2b37" />
    </Svg>
  )
}
